import React, { Component } from 'react';
import { getUserAuthToken } from '../../../../services/common/util';

export default class FileField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            preview: null
        };
        this.fileInputRef = React.createRef();
    }

    componentDidMount() {
        // If there's an existing value (server path), set preview
        if (this.props.value && typeof this.props.value === 'string' && !this.props.value.startsWith('data:')) {
            this.setState({
                preview: process.env.REACT_APP_BACKENDURL + this.props.value + '?token=' + getUserAuthToken()
            });
        }
    }

    handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            const fileData = {
                fileName: file.name,
                content: reader.result
            };
            this.setState({ preview: reader.result });
            this.props.onChange(this.props.fieldDef.fieldId, fileData);
        };
        reader.readAsDataURL(file);
    };

    handleBrowse = () => {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.click();
        }
    };

    render() {
        const { fieldDef, hasError, errorMessage, disabled } = this.props;
        const isRequired = fieldDef.validation && fieldDef.validation.required;
        const accept = (fieldDef.config && fieldDef.config.accept) || 'image/*';
        const isImage = accept.startsWith('image');

        return (
            <div className="form-group">
                <label>
                    {fieldDef.label}
                    {isRequired && <span className="text-danger"> *</span>}
                </label>
                <div>
                    <input
                        className="d-none"
                        type="file"
                        ref={this.fileInputRef}
                        onChange={this.handleFileChange}
                        accept={accept}
                        disabled={disabled}
                    />
                    <button
                        type="button"
                        className="btn btn-outline-info btn-sm"
                        onClick={this.handleBrowse}
                        disabled={disabled}
                    >
                        <i className="fa fa-upload" /> Browse
                    </button>
                    {this.state.preview && isImage && (
                        <div className="mt-2">
                            <img
                                src={this.state.preview}
                                alt="Preview"
                                style={{ maxWidth: '200px', maxHeight: '100px' }}
                            />
                        </div>
                    )}
                </div>
                <div className={hasError ? 'inline-errormsg' : 'hidden'}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true">
                        &nbsp;{errorMessage || 'This field is required.'}
                    </i>
                </div>
            </div>
        );
    }
}
